/* global window */

const queryString = require('query-string')

// Allow for testing of the new assets
if (window.location.search === '?dev=1') {
    window.localStorage.setItem('dev', 'true')
} else if (window.location.search === '?dev=0') {
    window.localStorage.setItem('dev', 'false')
}

const knownRoutes = [
    'beta',
    'token',
    'jumo/token',
    'reset',
    'password/reset',
]

const query = queryString.parse(window.location.search)

const stage = process.env.ENV || 'production'
const baseurl = `${process.env.API_BASE}/public` || 'https://api.namesandfaces.com/1/public'

// Basic routing
let route = window.location.pathname
    .replace(/\.html$/, '') // For local work
    .replace(/^\//, '')

if (knownRoutes.indexOf(route) === -1) {
    route = 'index'
}

module.exports = {
    stage,
    baseurl,
    route,
    query,
    dev : window.localStorage && window.localStorage.getItem('dev') === 'true',
}



/** WEBPACK FOOTER **
 ** ./js/credentials/env.js
 **/